import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdvisorsPage } from '@/pages/advisors';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * La lista resta montata e i pannelli del commercialista si aprono sopra di
 * lei sull'`Outlet` (`$id`, `new`, `edit/$id`), come nella webapp. Solo i SUPERADMIN
 * gestiscono i commercialisti: il controllo sta sul layout, così vale anche
 * per le rotte figlie aperte da un link.
 */
export const Route = createFileRoute('/admin/_layout/advisors/_layout')({
  beforeLoad: requireSuperadmin,
  component: AdvisorsLayout,
  validateSearch: commonSearchSchema,
});

function AdvisorsLayout() {
  return (
    <>
      <AdvisorsPage />
      <Outlet />
    </>
  );
}
